import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { forwardRef } from 'react';
import { navCssClassNames } from './navCssClassNames';
import { FixedSideNav } from './variants/FixedSideNav';
import { SideNav } from './variants/SideNav';
import { TopNav } from './variants/TopNav';
export const Nav = forwardRef(({ variant = 'top', isContained, isSticky, hasDivider, className, ...props }, ref) => {
    const { Component, componentProps } = {
        'top': {
            Component: TopNav,
            componentProps: {
                ...props,
                isContained,
                isSticky,
                hasDivider
            }
        },
        'side': {
            Component: SideNav,
            componentProps: props
        },
        'fixedSide': {
            Component: FixedSideNav,
            componentProps: props
        }
    }[variant];
    return (_jsx(Component, { ...componentProps, className: clsx(className, navCssClassNames.root), ref: ref }));
});
Nav.displayName = 'Nav';
